@if (menu()) {
<div class="menu">
    <div class="menu-item top">
        <div class="item-box">
            <div class="button top" [class.dimmed]="dimmed()" (click)="onToggle()">
                <mat-icon class="icon">menu</mat-icon>
            </div>
        </div>
    </div>
    @for (item of menu()?.items; track item._id; let i = $index) {
    <div [class.slid]="start()" [style.--slid-index]="i" class="menu-item slid-target" [style.top.rem]="top">
        @if(!item.hidden) {
        <div class="item-box">
            <div class="button" [class.focus]="isOpen(item)"
                (click)="onSelect(item)">
                <mat-icon class="icon" [style.display]="item.badge ? 'none': ''">{{item.icon}}</mat-icon>
                <div class="badge" [hidden]="!item.badge">{{item.badge}}</div>
            </div>
        </div>
        }
        <ng-container [dynamic]="item"></ng-container>
    </div>
    }
</div>
}
